import React from 'react'
import Iframe from 'react-iframe'
import styled from 'styled-components'

const CalendarBanner = styled.div`
  background: #F8F8F8;
  width: 100vw; 
  height: 100vh; 
  display: flex;
  justify-Content: center; 
  align-Items: center;
  padding-Right: 5vw;
  padding-Left: 5vw;

  flex-direction: column;
`

const CalendarTitle = styled.div`
  font-size: 4rem;
  font-family: Montserrat;
  font-weight: bold;
`

const CalendarContainer = styled.div`

  width: 100%;
  height: 80%;
`


export default function LeaveCalendar() {

    const FORM_URL = "https://calendar.google.com/calendar/embed?src=ic360leave%40gmail.com&ctz=Australia%2FSydney";
    return (
      <CalendarBanner>
        <CalendarTitle>
        IC360 & ALLROAD Leave Calendar
        </CalendarTitle>

        <CalendarContainer>
          <Iframe url={FORM_URL} width="100%" height = "100%" frameBorder="0"/>
        </CalendarContainer>
      </CalendarBanner>
    )
}
